export const filterSpecial = [
    {label: 'Tất cả', value: ''},
    {label: 'Nổi bật', value: 1},
    {label: 'Thông thường', value: 0},
];